import {
  Tooltip,
  Card,
  Typography,
  Input,
  Button,
  Pagination,
  Switch,
  Form,
  Empty,
  Tag,
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SortingArrow from "../../Common/SortingArrow";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import { changeLoader } from "../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
import { checkPermissionAction } from "../../utils/helper/utils";

let timer = null;

const ManageCannedVendingMachine = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Search } = Input;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  const [itemData, setItemData] = useState(0);

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_CANNED_VENDING_MACHINE?.UPDATE + "/" + itemData.clientid,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Canned Vending Machine deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllMachines();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllMachines = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_CANNED_VENDING_MACHINE.GET,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.rows || apiResponse?.data || []);
        setTotalRows(apiResponse?.data?.total || apiResponse?.data?.length || 0);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllMachines();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const getStatusColor = (status) => {
    switch (status) {
      case '1': return 'green';
      case '0': return 'red';
      default: return 'default';
    }
  };

  const getOnlineStatusColor = (online) => {
    return online === "1" ? "green" : "red";
  };

  const getAbnormalColor = (abnormal) => {
    return abnormal === "1" ? "red" : "green";
  };

  return (
    <>
      <Card>
        <div className="flex flex-wrap justify-between mb-4 gap-3">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Manage Canned Vending Machine
            </Typography>
          </div>
          <div className="flex flex-wrap gap-3">
            <Form form={form} layout="vertical">
              <Search
                placeholder="Search by Machine name"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "trim");
                  form.setFieldValue("search", value);
                  setInputData((prev) => ({ ...prev, search: value }));
                  setPaginationModel((prev) => ({ ...prev, page: 1 }));
                }}
                style={{
                  width: 250,
                }}
                className="cursor-pointer"
              />
            </Form>
            {checkPermissionAction("Canned Vending Machine", permissionJson, "add") ? (
              <Button
                type="primary"
                size={14}
                icon={<PlusOutlined />}
                className="cursor-pointer"
                onClick={() => navigate("/add-canned-vending-machine")}
              >
                Add Canned Vending Machine
              </Button>
            ) : null}
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-500">
            <thead className="text-gray-700 capitalize text-xs bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Name <SortingArrow onSort={(order) => handleSort("name", order)} />
                </th>
                <th scope="col" className="px-3 py-3">Machine ID (CSN)</th>
                <th scope="col" className="px-3 py-3">Type</th>
                <th scope="col" className="px-3 py-3">Sellers</th>
                <th scope="col" className="px-3 py-3">Inventory</th>
                <th scope="col" className="px-3 py-3">Online</th>
                <th scope="col" className="px-3 py-3">Health</th>
                <th scope="col" className="px-3 py-3">Status</th>
                <th scope="col" className="px-3 py-3 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list
                  ?.filter((item) => item.status !== "deleted")
                  ?.map((item, index) => (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-3 py-4 vertical-top font-medium text-gray-900">{item?.name || item?.csn || "-"}</td>
                    <td className="px-3 py-4 vertical-top">{item?.csn || "-"}</td>
                    <td className="px-3 py-4 vertical-top">{item?.type || "-"}</td>
                    <td className="px-3 py-4 vertical-top">{item?.sellersCount || item?.productsCount || 0}</td>
                    <td className="px-3 py-4 vertical-top">{item?.inventory || 0}</td>
                    <td className="px-3 py-4 vertical-top">
                      <Tag color={getOnlineStatusColor(item?.online)}>{item?.online === "1" ? "Online" : "Offline"}</Tag>
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      <Tag color={getAbnormalColor(item?.abnormal)}>{item?.abnormal === "1" ? "Abnormal" : "Healthy"}</Tag>
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      <Tag color={getStatusColor(item?.status)}>{item?.status === "1" ? "Active" : "Inactive"}</Tag>
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                      <Tooltip title="Edit">
                        <EditOutlined
                          onClick={() => {
                            if (checkPermissionAction("Canned Vending Machine", permissionJson, "edit")) {
                              navigate("/edit-canned-vending-machine/" + item.clientid);
                            }
                          }}
                          className={`mx-1.5 cursor-pointer ${!checkPermissionAction("Canned Vending Machine", permissionJson, "edit") ? "text-gray-400 cursor-not-allowed" : ""}`}
                        />
                      </Tooltip>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          className={`mx-1.5 cursor-pointer ${!checkPermissionAction("Canned Vending Machine", permissionJson, "delete") ? "text-gray-400 cursor-not-allowed" : ""}`}
                          onClick={() => {
                            if (checkPermissionAction("Canned Vending Machine", permissionJson, "delete")) {
                              setIsDeleteModalOpen(true);
                              setItemData(item);
                            }
                          }}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9} className="text-center py-4">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) => setPaginationModel((prev) => ({ ...prev, page: page }))}
              onShowSizeChange={(current, size) => setPaginationModel((prev) => ({ ...prev, limit: size }))}
            />
          </div>
        ) : null}
      </Card>
      <ConfirmationModal
        ConfirmationHeading="Delete"
        ConfirmationParagraph="Are you sure you want to delete this Vending Machine?"
        isOpen={isDeleteModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleDeleteCancel}
      />
    </>
  );
};

export default ManageCannedVendingMachine;
